<ngx-spinner bdOpacity=0.9 size="medium" color="#FF416C" type="ball-spin" [fullScreen]="false" color="skyblue">
</ngx-spinner>

<body>
    <div class="login-body" fxFlex fxLayout="row">
        <div class="container">
            <div class="form-container" id="container">
                <!-- <img src="../../../../../assets/images/cwc-logo.png"> -->
                <form [formGroup]="loginFormGroup" id="container" class="padding-15px">
                    <h3 style="margin-bottom: 30px;">{{'login' | translate }}</h3>
                    <mat-form-field appearance="outline" fxFlex>
                        <mat-label>Email*</mat-label>
                        <input placeholder="Email" matInput formControlName="email" (input)="OnInputData($event)"
                            pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$">
                        <mat-hint class="color-red"
                            *ngIf="loginFormGroup.get('email').touched && loginFormGroup.get('email').errors?.required">
                            Email required</mat-hint>
                        <mat-hint class="color-red"
                            *ngIf="!(loginFormGroup.get('email').errors?.required) && loginFormGroup.get('email').invalid">
                            Please enter a valid email</mat-hint>
                    </mat-form-field>
                    <button type="button" class="button submit-button theme-button"
                        [disabled]="!loginFormGroup.get('email').valid || disablePasscode" mat-flat-button
                        (click)="OnBtnClicked()"><b>{{ 'Get Passcode' | translate }}</b></button>
                    <mat-form-field appearance="outline" fxFlex>
                        <mat-label>Passcode*</mat-label>
                        <input placeholder="Passcode" matInput [type]="hidePassword ? 'password' : 'text'"
                            formControlName="otp" (input)="onPasswordText($event)"
                            onkeypress="if(this.value.length===8)return false;" oncopy="return false"
                            ondrag="return false" onpaste="return false" ondrop="return false">
                        <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-hint class="color-red"
                            *ngIf="loginFormGroup.get('otp').touched && loginFormGroup.get('otp').errors?.required">
                            Passcode required</mat-hint>
                    </mat-form-field>
                    <div fxLayout="column" fxLayoutAlign="space-between center" class="pb10">
                        <div fxLayout fxLayoutAlign="start center" class="mb-12">
                            <img [src]="image" class="imgHeight" />
                            <button mat-icon-button type="button" matTooltip="Refresh Captcha">
                                <mat-icon class="refresh-icon" (click)="refreshCaptcha()">refresh</mat-icon> 
                                                               
                            </button>
                        </div>
                        <mat-form-field appearance="outline" fxFlex>
                            <mat-label>Captcha*</mat-label>
                            <input type="text" matInput formControlName="captcha" autocomplete="off"
                                onkeypress="if(this.value.length===6)return false;"
                                (input)="onCaptchaEntered($event.target.value)">
                            <mat-hint class="color-red"
                                *ngIf="loginFormGroup.get('captcha').touched && loginFormGroup.get('captcha').errors?.required">
                                Captcha required
                            </mat-hint>
                        </mat-form-field>
                    </div>
                    <button type="submit" [disabled]="loginFormGroup.invalid || disableSubmitBtn || disableOnCaptcha"
                        class="button submit-button theme-button" mat-flat-button
                        (click)="onLoginBtnClicked()"><b>{{ 'login' | translate }}</b></button>
                </form>
            </div>
        </div>
    </div>
</body>